import { Timestamp } from 'firebase/firestore';

export type ReactionType = '😊' | '😁' | '🤩' | '💯' | '❤️';

export const REACTION_TYPES: ReactionType[] = ['😊', '😁', '🤩', '💯', '❤️'];

export interface Reaction {
  goodThingId: string;
  userId: string;
  userDisplayName: string;
  reactionType: ReactionType;
  createdAt: Timestamp;
}

export interface ReactionWithId extends Reaction {
  id: string;
}

export interface ReactionCount {
  count: number;
  users: Array<{
    id: string;
    displayName: string;
  }>;
}

export type ReactionsByType = Record<ReactionType, ReactionCount>;